import { EdiUploadError, FranchiseUploadError } from 'services/batchOrder/interfaces'
import { HeadItemType, Table } from 'components/Table'

import * as S from './styles'
import { formatDate } from 'commons/utils/date'

const headDataEdi: HeadItemType[] = [
  { label: 'Número da coluna', columnName: 'nr_linh' },
  { label: 'Descrição de erro', columnName: 'ds_msg' }
]

const headDataFranchises: HeadItemType[] = [
  { label: 'Tipo OV', columnName: 'TipoOV' },
  { label: 'Quebra', columnName: 'Quebra' },
  { label: 'Prev. Faturam.', columnName: 'DataPrevistaFaturamento' },
  { label: 'Fábrica', columnName: 'Centro' },
  { label: 'Cond. Pagam.', columnName: 'CondicaoPagamento' },
  { label: 'Cliente', columnName: 'Cliente' },
  { label: 'Material', columnName: 'Material' },
  { label: 'Tamanho', columnName: 'Tamanho' },
  { label: 'Cor', columnName: 'Cor' },
  { label: 'Erro', columnName: 'ErrorMenssage' }
]

interface UploadSpreadsheetTableErrorProps {
  data: EdiUploadError[] | FranchiseUploadError[]
}

const UploadSpreadsheetTableError: React.FC<UploadSpreadsheetTableErrorProps> = ({
  data
}) => {
  const isEdiError = (
    item: EdiUploadError | FranchiseUploadError
  ): item is EdiUploadError => {
    return (item as EdiUploadError).nr_linh !== undefined
  }

  const renderSummary = () => {
    const amount = data?.length ?? 0
    return amount > 1 ? `${amount} erros encontrados` : `${amount} erro encontrado`
  }

  const renderBody = () => {
    return data.map((item) => {
      if (isEdiError(item)) {
        const key = `${item.nr_linh}-${item.ds_msgm}`

        return {
          id: `id-${key}`,
          content: [
            <S.DataWrap key={`colNumber-${key}`}>
              <span>{item.nr_linh}</span>
            </S.DataWrap>,
            <S.DataWrap key={`ErrorDescription-${key}`}>
              <span>{item.ds_msgm}</span>
            </S.DataWrap>
          ]
        }
      }

      const key = `${item.TipoOV}-${item.Quebra}-${item.DataPrevistaFaturamento}-${item.ErrorMenssage}`

      return {
        id: `id-${key}`,
        content: [
          <S.DataWrap key={`TipoOV-${key}`}>
            <span>{item.TipoOV}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Quebra-${key}`}>
            <span>{item.Quebra}</span>
          </S.DataWrap>,
          <S.DataWrap key={`DataPrevistaFaturamento-${key}`}>
            <span>{formatDate(item.DataPrevistaFaturamento)}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Centro-${key}`}>
            <span>{item.Centro}</span>
          </S.DataWrap>,
          <S.DataWrap key={`CondicaoPagamento-${key}`}>
            <span>{item.CondicaoPagamento}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Cliente-${key}`}>
            <span>{item.Cliente}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Material-${key}`}>
            <span>{item.Material ?? '-'}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Tamanho-${key}`}>
            <span>{item.Tamanho ?? '-'}</span>
          </S.DataWrap>,
          <S.DataWrap key={`Cor-${key}`}>
            <span>{item.Cor ?? '-'}</span>
          </S.DataWrap>,
          <S.DataWrap key={`ErrorMenssage-${key}`}>
            <span>{item.ErrorMenssage}</span>
          </S.DataWrap>
        ]
      }
    })
  }

  const headData =
    data.length > 0 && isEdiError(data[0]) ? headDataEdi : headDataFranchises

  return (
    <S.Container>
      <S.Summary>{renderSummary()}</S.Summary>
      <Table
        headData={headData}
        bodyData={renderBody()}
        rowHeight={40}
        distributeWidth={false}
      />
    </S.Container>
  )
}

export default UploadSpreadsheetTableError
